import {t} from "../../../../../store/localization/TranslMessasge";
import {CommonTranslationKey} from "../../CommonTranslationKey";
import {ErrorTranslationKey} from "../../ErrorTranslationKey";
import Snackbar from "../../snackbar/Snackbar";
import DeleteConfirmationDialog from "../../../../../components/dialogs/DeleteConfirmationDialog";
import {UserGroupsTranslationKey} from "../UserGroupsTranslationKey";
import {useRemoveUserGroupMemberMutation} from "../UserGroupQuery";

export interface UserGroupMemberDeleteDialogProps {
    open: boolean;
    groupId: string;
    userLogin: string;
    title?: string;
    onClose: () => void;
}

export default function UserGroupMemberDeleteDialog(props: Readonly<UserGroupMemberDeleteDialogProps>) {
    const {open, groupId, userLogin, title, onClose} = props;

    const removeMemberMutation = useRemoveUserGroupMemberMutation();

    function removeMember() {
        removeMemberMutation.mutate({groupId, userLogin}, {
            onSuccess: () => {
                onClose();
                Snackbar.success(t(CommonTranslationKey.DATA_SAVED_SUCCESSFULLY));
            },
            onError: (err) => {
                Snackbar.error(t(ErrorTranslationKey.UNEXPECTED_ERROR_OCCURRED), err);
            },
        });
    }

    return (
            <DeleteConfirmationDialog
                    open={open}
                    title={title ?? t(UserGroupsTranslationKey.REMOVE_MEMBER_QUESTION_MARK)}
                    message={t(UserGroupsTranslationKey.MEMBERSHIP_WILL_BE_REMOVED)}
                    confirmButtonLabel={t(CommonTranslationKey.REMOVE)}
                    deleteDisabled={removeMemberMutation.isPending}
                    onDelete={removeMember}
                    onDismiss={onClose}/>
    );
}